import { post } from './client'
import type { BackendMeta } from './types'

export type MoveProject = BackendMeta<
  '/api/workspaces/{workspace_id}/projects/{project_id}/move_to_folder',
  'post'
>

/** Move a project to a new parent folder. */
export const moveProject = ({
  parentFolderId,
  projectId,
  workspaceId,
}: {
  workspaceId: string
  projectId: string
  parentFolderId: string | null
}) => {
  return post<MoveProject['body'], MoveProject['successResponse'], MoveProject['path']>(
    `/api/workspaces/${workspaceId}/projects/${projectId}/move_to_folder`,
    {
      parent_folder_id: parentFolderId,
    },
  )
}
